import {SunEditorOptions} from "suneditor/src/options";
import {Plugin} from "suneditor/src/plugins/Plugin";
import {CommandPlugin} from "suneditor/src/plugins/CommandPlugin";
import plugins from "suneditor/src/plugins";
import {EventEmitter} from "@angular/core";

export class EditorBO{
  editorOptions: SunEditorOptions = {
    minWidth: "100%",
    height: "325px",
    font: [
      'var',
      'tohoma',
      'Bakh',
      'BTitrBold'
    ]

  };


  editorOptionsLite: SunEditorOptions = {
    minWidth: "100%",
    height: "150px",
    font: [
      'vzr',
      'tohoma',
      'Bakh',
      'BTitrBold'
    ],

  };

  constructor() {
    this.addCustomPlugin();
  }


  addCustomPlugin() {
    var plugin_searchia_title: Plugin = {
      name: 'titleCommand',
      display: 'command',
      title: 'عنوان',
      buttonClass: '',
      // This icon uses Font Awesome
      innerHTML: '<i class="pi pi-id-card"></i>',
      add: function (core: any, targetElement: Element) {
        // const context = core.context;
        // context.titleCommand = {
        //   targetButton: targetElement
        // };
      },
      active: function (element: HTMLElement) {
        // if (!element) {
        //   element.util.removeClass(element.context.titleCommand.targetButton, 'active');
        // } else if (element.classList.contains('searchia-docs-title')) {
        //   element.util.addClass(element.context.titleCommand.targetButton, 'active');
        //   return true;
        // }

        return true;
      }
    }
    plugins.lineHeight

    var pluginss = [
      plugins.blockquote,
      plugins.align,
      plugins.font,
      plugins.fontSize,
      plugins.fontColor,
      plugins.hiliteColor,
      plugins.horizontalRule,
      plugins.list,
      plugins.table,
      plugins.formatBlock,
      plugins.lineHeight,
      plugins.template,
      plugins.paragraphStyle,
      plugins.textStyle,
      plugins.link,
      plugins.image,
      plugins.video,
      plugins.audio,
      plugins.math,
      plugins.imageGallery,
      plugin_searchia_title
    ]
    this.editorOptions.plugins= pluginss;


    var btnList = [
      ["undo", "redo"],
      // ["font", "fontSize", "formatBlock"],
      [ "fontSize", "formatBlock"],
      ["paragraphStyle", "blockquote"],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      ["fontColor", "hiliteColor", "textStyle"],
      ["removeFormat"],
      ["outdent", "indent"],
      ["align", "horizontalRule", "list", "lineHeight"],
      // ["table", "link", "image", "video", "audio"],
      ["table", "link"],
      [ "showBlocks", "codeView"],
      // ["fullScreen","preview", "print"],
      // ["save", "template"],
      // ["titleCommand"],
    ]
    this.editorOptions.buttonList=btnList;
    this.editorOptions.templates=[
      {
        name: 'Template-1',
        html: '<p>HTML source1</p>'
      },
      {
        name: 'Template-2',
        html: '<p>HTML source2</p>'
      }
    ];

    var btnListLite = [
      ["undo", "redo"],
      [ "fontSize", "formatBlock"],

      ["paragraphStyle", "blockquote"],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      ["fontColor", "hiliteColor", "textStyle"],
      ["removeFormat"],
      ["outdent", "indent"],
      ["align", "horizontalRule", "list", "lineHeight"],
      [ "link", "image"],
      [ "codeView"],
    ]

    this.editorOptionsLite.plugins= pluginss;
    this.editorOptionsLite.buttonList=btnListLite;

  }







// image resize
  onImageUploadBefore = function (files, info, core, uploadHandler) {
    try {
      this.resizeImage(files, uploadHandler)
    } catch (err) {
      uploadHandler(err.toString())
    }
  };
   resizeImage (files, uploadHandler) {
    const uploadFile = files[0];
    const img = document.createElement('img');
    const canvas = document.createElement('canvas');
    const reader = new FileReader();

    reader.onload = function (e) {
      // @ts-ignore
      img.src = e.target.result
      img.onload = function () {
        let ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        const MAX_WIDTH = 200;
        const MAX_HEIGHT = 100;
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }

        canvas.width = width;
        canvas.height = height;

        ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(function (blob) {
          uploadHandler([new File([blob], uploadFile.name)])
        }, uploadFile.type, 1);
      }
    }

    reader.readAsDataURL(uploadFile);
  }


}
